let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hzLOt")).then(() => parcelRequire('d0lkZ'));